
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import Banner from '@/components/banner/Banner.vue';
import BackArrowIcon from '@/components/icons/BackArrowIcon.vue';
import DownloadIcon from '@/components/icons/DownloadIcon.vue';
import { getLogisiticsListByOrder } from '@/api/apis';
import { downloadFile } from '@/api/request';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'PartLogisticsInfo',
  components: {
    Banner,
    BackArrowIcon,
    DownloadIcon
  },
  data() {
    const orderNum = (this.$route.query.orderNo as string) || '';
    return {
      moment,
      loading: false,
      orderNum,
      colTitle: [
        'tracking_no',
        'order_no',
        'batch',
        'unit',
        'quantity',
        'delivery_method',
        'status',
        'etd',
        'eta',
        'remark'
      ],
      columns: [
        {
          dataIndex: 'logisticsNum',
          width: 160,
          slots: {
            customRender: 'logisticsNum',
            title: 'tracking_no-title'
          }
        },
        {
          width: 120,
          slots: { customRender: 'order-no', title: 'order_no-title' }
        },
        {
          dataIndex: 'batch',
          width: 100,
          slots: { customRender: 'batch', title: 'batch-title' }
        },
        {
          dataIndex: 'unit',
          width: 100,
          slots: { customRender: 'unit', title: 'unit-title' }
        },
        {
          dataIndex: 'quantity',
          width: 100,
          slots: {
            title: 'quantity-title'
          }
        },
        {
          dataIndex: 'deliveryMethod',
          width: 140,
          slots: {
            title: 'delivery_method-title'
          }
        },
        {
          dataIndex: 'status',
          width: 100,
          slots: {
            customRender: 'status',
            title: 'status-title'
          }
        },
        {
          dataIndex: 'etd',
          width: 100,
          slots: { customRender: 'etd', title: 'etd-title' }
        },
        {
          dataIndex: 'eta',
          width: 100,
          slots: { customRender: 'eta', title: 'eta-title' }
        },
        {
          width: 100,
          dataIndex: 'remark',
          slots: { title: 'remark-title' }
        }
      ],
      dataSource: [],
      id: 0,
      ipagination: {
        current: 1,
        pageSizeOptions: ['5', '10', '15'],
        total: 0,
        showSizeChanger: true,
        pageSize: 5,
        showQuickJumper: true
        // size: 'large'
      }
    };
  },
  created() {
    const id = +(this.$route.params.id as string);
    if (!isNaN(id) && id > 0) {
      this.id = id;
      this.loadData();
    }
  },
  computed: {
    ...mapState(['lang', 'userInfo'])
  },
  methods: {
    async handleDownload() {
      const paramArr: string[] = [];
      paramArr.push(`customerId=${this.userInfo.id}`);
      paramArr.push(`locale=${this.lang}`);

      await downloadFile(
        `${baseUrl}ureport/excel?_u=db:user_logistics_list_by_order_excel.ureport.xml&orderId=${
          this.id
        }&${paramArr.join('&')}`,
        this.$t('order.part_logistics_title') + this.orderNum + '.xlsx',
        null
      );
    },
    getStatus(status) {
      let res = '';

      if (!isNaN(status) && status !== null && status >= 0) {
        res = this.$t(`logistics_status.${status}`);
      }
      return res;
    },
    async loadData() {
      this.loading = true;

      const res = await getLogisiticsListByOrder({
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        orderId: this.id
      });

      if (res.success) {
        this.ipagination.total = res.result.total;
        this.dataSource = res.result.records || [];
      }

      this.loading = false;
    },
    onShowSizeChange(current) {
      this.ipagination.current = current;

      this.loadData();
    },
    onChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;

      this.loadData();
    },
    handleBack() {
      this.$router.push('/order?tab=2');
    },
    goToDetail(record) {
      this.$router.push(`/part-logistics-detail/${record.id}`);
    }
  }
});
